import { Column } from "@carbon/react";

import { CustomNavLink } from "../CustomNavLink";
import { CopyButton } from "../CopyButton";
import { LoanOfferAvailableBanner } from "../LoanOfferAvailableBanner";

export const View = ({
  active_tenant_id,
  activeTenantHandle,
  pageTabNavLinks,
  boundedUnderline = false,
  className = "" /*search*/,
}) => {
  return (
    <>
      {/* Display side-by-side tabs for lg screens */}
      <Column lg={16} md={8} sm={0} className={`page-tab--links ${className}`}>
        <div className="flex-container justify-content--between align-items--end">
          <div>
            {pageTabNavLinks.map((link) => (
              <CustomNavLink
                key={link.route}
                // to={`${link.route}${search}`}
                to={`${link.route}`}
                className="page-tab--nav-link"
              >
                <span
                  /* className="link-name"*/ style={{ display: "inline-block" }}
                >
                  {link.name}
                </span>
              </CustomNavLink>
            ))}
          </div>

          {!activeTenantHandle ? null : (
            <div className="merchant-id-or-handle">
              <div
                title="use this transfer handle to manage sending money between merchants on SwitchApp."
                className="flex-container justify-content--start align-items--center no-wrap"
              >
                <div className="merchant-handle--container modal-header--title">
                  <span>SwitchApp Handle: {activeTenantHandle}</span>
                </div>
                <div className="copy-button--container ml-3">
                  <CopyButton
                    name="copy-beneficiary-id-button"
                    stringToCopy={activeTenantHandle}
                    iconDescription="copy SwitchApp transfer handle"
                    className="copy-btn"
                  />
                </div>
              </div>

              {/* <span>Merchant ID: {active_tenant_id}</span> */}
            </div>
          )}
        </div>

        <div
          className={`page-tab--underline ${
            boundedUnderline ? "bounded-underline" : ""
          }`}
        />

        <LoanOfferAvailableBanner />
      </Column>

      {/* Display single line for sm screens */}
      {/* <Column
        lg={0}
        md={0}
        sm={4}
        className="page-tab--links small-screen--only"
      >
        <Grid>
          {pageTabNavLinks.map((link) => (
            <Column sm={4}>
              <NavLink
                key={link.route}
                to={link.route}
                className="page-tab--nav-link"
              >
                - {link.name}
              </NavLink>
            </Column>
          ))}
        </Grid>
      </Column> */}
    </>
  );
};
